import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_1;
}

export default GravelRoadTileEntity1;
